import React, {ReactNode} from 'react'
import {cx} from '@emotion/css'
import styled from '@emotion/styled'
import {ColorPath} from 'types/Theme'

import {Card} from '@vio/atlas/Card'
import {linariaMq} from '@vio/atlas/src/utils/breakpoints'
import {getCssColorByPath} from '@vio/atlas/src/utils/colors'
import {cssTheme} from '@vio/atlas/themes'

const BorderCard = styled(Card)`
  border-width: 1px;
  &.--is-highlighted {
    border-width: 2px;
  }
  .--room-card-gallery {
    border-top-left-radius: ${cssTheme.layout.radius.none};
    border-top-right-radius: ${cssTheme.layout.radius.none};
    ${linariaMq.desktopSm} {
      border-top-left-radius: ${cssTheme.layout.radius.lg};
      border-top-right-radius: ${cssTheme.layout.radius.lg};
    }
  }
`

const HeaderLayoutWrapper = styled('div')<{
  bgColor: string
  contentColor: string
}>`
  background: ${({bgColor}) => bgColor};
  color: ${({contentColor}) => contentColor};
  display: flex;
  align-items: center;
  gap: ${cssTheme.layout.spacing.s300};
  padding: ${cssTheme.layout.spacing.s300} ${cssTheme.layout.spacing.s400};
`

export const RoomCardHeaderLayout = ({
  iconSlot,
  titleSlot,
  children,
  bgColorPath = 'background.brand.secondary',
  contentColorPath = 'content.brand.primary',
  borderColorPath = 'border.neutral.secondary',
  isHighlighted = false,
  dataId
}: {
  children: ReactNode
  iconSlot?: ReactNode
  titleSlot?: ReactNode
  dataId?: string
  bgColorPath?: ColorPath
  contentColorPath?: ColorPath
  borderColorPath?: ColorPath
  isHighlighted?: boolean
}) => {
  return (
    <BorderCard
      borderRadius="xl"
      borderColorPath={borderColorPath}
      className={cx(isHighlighted && '--is-highlighted')}
      dataId={dataId}
    >
      {iconSlot && titleSlot && (
        <HeaderLayoutWrapper
          bgColor={getCssColorByPath(bgColorPath)}
          contentColor={getCssColorByPath(contentColorPath)}
        >
          {iconSlot}
          {titleSlot}
        </HeaderLayoutWrapper>
      )}
      {children}
    </BorderCard>
  )
}
